import React from 'react';
import {RightOutlined} from "@ant-design/icons";
import style from "./BackBtn.module.scss";
import {useNavigate} from "react-router-dom";

const BackButton = () => {
    let navigate = useNavigate();

    return (

            <RightOutlined onClick={() => navigate(-1)} className={style.customIcon}/>

    );
};

export default BackButton;
